const getStickyHeaderHeight = (): number | undefined => {
  const element = document.getElementById('sticky-header');
  if (!element) {
    return undefined;
  }
  const height = element.offsetHeight;
  return height;
};

export default getStickyHeaderHeight;
